define([
    'angular',
    'angular-resource',
    '../models/lead',
    '../../user/services/loginCheck',
], function (angular) {
    return angular
        .module('leadServices', [
            'ngResource',
            'leadModels',
            'loginCheckServices',
        ])
        .factory('Leads', [
            '$interval',
            '$resource',
            '$rootScope',
            'LeadModel',
            'LoginCheck',
            function ($interval, $resource, $rootScope, LeadModel, LoginCheck) {
                var resource = $resource(
                    $rootScope.Routing.generate('leads', { _format: 'json' }),
                    [],
                    {
                        delete: {
                            method: 'DELETE',
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('delete_lead', {
                                    lead: ':id',
                                    _format: 'json',
                                })
                            ),
                        },
                        get: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('view_lead', {
                                    lead: ':id',
                                    _format: 'json',
                                })
                            ),
                            method: 'GET',
                            isArray: false,
                            transformResponse: function (data) {
                                var modelData = {};
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse lead as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                return new LeadModel(modelData);
                            },
                        },
                        getCounts: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('lead_counts', {
                                    _format: 'json',
                                })
                            ),
                            method: 'GET',
                            isArray: false,
                        },
                        getMyPriceHistory: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('view_myself', {
                                    _format: 'json',
                                })
                            ),
                            method: 'GET',
                            isArray: false,
                            transformResponse: function (data) {
                                return new LeadModel(JSON.parse(data));
                            },
                        },
                        getMyself: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('view_myself', {
                                    _format: 'json',
                                })
                            ),
                            method: 'GET',
                            isArray: false,
                            transformResponse: function (data) {
                                var modelData = {};
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse lead as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                return new LeadModel(modelData);
                            },
                        },
                        query: {
                            method: 'GET',
                            isArray: true,
                            transformResponse: function (data) {
                                var modelData = [];
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse leads as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                for (i in modelData) {
                                    modelData[i] = new LeadModel(modelData[i]);
                                }
                                return modelData;
                            },
                        },
                        save: {
                            method: 'POST',
                            isArray: false,
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('create_lead', {
                                    _format: 'json',
                                })
                            ),
                            transformResponse: function (data) {
                                var modelData = {};
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse lead as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                return new LeadModel(modelData);
                            },
                        },
                        update: {
                            method: 'PUT',
                            isArray: false,
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('update_lead', {
                                    _format: 'json',
                                    lead: ':id',
                                })
                            ),
                            transformResponse: function (data) {
                                var modelData = {};
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse lead as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                return new LeadModel(modelData);
                            },
                        },
                    }
                );

                var leads = false;
                var loadLeads = true;
                var lastParams = {};
                var leadCounts = false;
                var leadCountRefresh = false;
                var myself = false;
                var myPriceHistory = false;
                var service = {
                    deleteLead: function (lead, callback) {
                        if (leads) {
                            var i = leads.indexOf(lead);
                            if (i > -1) {
                                leads.splice(i, 1);
                            }
                        }
                        lead.delete(callback);
                    },
                    get: function (id, callback) {
                        var lead = resource.get({ id: id });
                        if (typeof callback == 'function') {
                            lead.$promise.then(callback);
                        }
                        return lead;
                    },
                    getLeadCounts: function (callback) {
                        if (!leadCounts) {
                            leadCounts = resource.getCounts();
                        }

                        if (typeof callback == 'function') {
                            leadCounts.$promise.then(callback);
                        }

                        // Update periodically to keep counts in nav up to date
                        if (leadCountRefresh === false) {
                            leadCountRefresh = $interval(function () {
                                service.updateLeadCounts();
                            }, 5000 * 60);
                        }

                        return leadCounts;
                    },
                    getLeads: function (parameters, callback, forceReload) {
                        var params = {};
                        angular.forEach(parameters, function (value, key) {
                            // Strip out internal Angular variables because they're causing
                            // some circular reference errors on JSON serialization
                            if (key.indexOf('$') !== 0) {
                                params[key] = value;
                            }
                        });
                        var newParams = false;
                        angular.forEach(params, function (value, key) {
                            if (lastParams[key] != value) {
                                newParams = true;
                            }
                        });
                        angular.forEach(lastParams, function (value, key) {
                            if (params[key] != value) {
                                newParams = true;
                            }
                        });
                        if (
                            forceReload ||
                            newParams ||
                            loadLeads ||
                            params.limit
                        ) {
                            lastParams = params;
                            leads = resource.query(params);
                            loadLeads = false;
                        }
                        if (typeof callback == 'function') {
                            leads.$promise.then(callback);
                        }
                        return leads;
                    },
                    getMyPriceHistory: function () {
                        if (!myPriceHistory) {
                            myPriceHistory = resource.getMyPriceHistory();
                        }

                        return myPriceHistory;
                    },
                    getMyself: function () {
                        if (!myself) {
                            myself = resource.getMyself();
                        }

                        return myself;
                    },
                    newLead: function () {
                        return new LeadModel(new resource());
                    },
                    resetLeads: function () {
                        loadLeads = true;
                    },
                    updateLeadCounts: function (filter) {
                        resource.getCounts(filter).$promise.then(
                            function (data) {
                                angular.forEach(data, function (value, key) {
                                    leadCounts[key] = value;
                                });
                            },
                            function (response) {
                                LoginCheck.checkAuthError(response);
                            }
                        );
                    },
                };

                return service;
            },
        ]);
});
